import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Progress,
  Select,
  Space,
  Tag,
  Upload,
} from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import { ORANGE } from '../../../../shared/colors';
import {
  addAML,
  addKYC,
  getUserAML,
  getUserKYC,
  updateAML,
  updateKYC,
} from '../../../dashboard/components/Monitor/network';
import { BASE_MEDIA } from '../../../shared/ApiRoutes';

const Container = styled.div`
  font-family: Poppins-R;
  zoom: 0.95;
  height: 100%;

  Input,
  Textarea,
  .ant-upload,
  Upload {
    margin-bottom: 15px;
    margin-top: 15px;
  }

  label {
    color: black;
  }

  .button {
    padding: 10px 15px 10px 15px;
    border-radius: 5px;
    margin-botton: 10px;
    background-color: ${ORANGE};
    color: white;
  }

  .photo {
    width: 100px;
    margin-bottom: 10px;
    cursor: zoom-in;
    transition: transform 0.2s;
  }

  .photo:hover {
    transform: scale(1.05);
  }
`;

export const KYCUserForm = ({
  userToUpdate,
  setShowDrawer,
  getNewClient,
}: {
  userToUpdate?: UserEntity;
  setShowDrawer: (b: boolean) => void;
  getNewClient: (part: DetenteurEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setpreviewImage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    updateProgress(updated, files);
  };

  const [formData, setFormData] = useState({
    full_name: '',
    birth_date: '',
    nationality: '',
    id_type: '',
    id_number: '',
    address: '',
    employment_status: '',
    income_level: '',
    investment_purpose: '',
    politically_exposed: 'non',
    country_of_residence: '',
  });

  const [files, setFiles] = useState<{ [key: string]: File }>({});

  const handleFile = (name, file) => {
    const updated = { ...files, [name]: file };
    setFiles(updated);
    updateProgress(formData, updated);
  };
  const [completion, setCompletion] = useState(0);

  const handleDownloadPDF = async () => {
    try {
      const res = await axios.get('/api/kyc/pdf/', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Mon_Dossier_KYC.pdf');
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      message.error('Impossible de télécharger le dossier PDF.');
    }
  };

  useEffect(() => {
    fetchData();
  }, [userToUpdate, form]);

  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [kyc, setKYC] = useState<any>({});
  const [aml, setAML] = useState<any>({});

  const handleSubmit = async () => {
    if (userToUpdate) {
      setIsLoading(true);
      const data = new FormData();

      // Ajoute les champs texte
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      });

      // Ajoute seulement les fichiers nouvellement sélectionnés
      Object.entries(files).forEach(([key, value]) => {
        if (value) {
          data.append(key, value);
        }
      });

      data.append('user', userToUpdate.id);
      data.append('status', 'verified');

      try {
        if (kyc && kyc.id) {
          await updateKYC(kyc.id, data);
          message.success('Informations KYC mises à jour');
        } else {
          await addKYC(data);
          message.success('KYC soumis avec succès');
        }

        // ajouter le AML
        if (aml && aml.id) {
          const data1 = new FormData();
          data1.append('income_level', formData.income_level);
          data1.append('country_of_residence', formData.country_of_residence);
          data1.append('is_pep', formData.politically_exposed);
          data1.append('user', connectedUser.id);
          await updateAML(aml.id, data1);
        } else {
          const data1 = new FormData();
          data1.append('income_level', formData.income_level);
          data1.append('country_of_residence', formData.country_of_residence);
          data1.append('is_pep', formData.politically_exposed);
          data1.append('user', connectedUser.id);
          await addAML(data1);
        }

        await fetchData(); // Recharge les données
      } catch (error) {
        message.error('Erreur lors de la soumission');
      }

      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    if (userToUpdate) {
      await getUserKYC(userToUpdate.id).then(async ({ data }) => {
        setKYC(data);
        if (data.error) {
          if (data.error === 'KYC introuvable') {
          }
        } else {
          setKYC(data);
          // Préremplir les valeurs texte
          setFormData({
            full_name: data.full_name || '',
            birth_date: data.birth_date ? data.birth_date.slice(0, 10) : '',
            nationality: data.nationality || '',
            id_type: data.id_type || '',
            id_number: data.id_number || '',
            address: data.address || '',
            employment_status: data.employment_status || '',
            income_level: data.income_level || '',
            investment_purpose: data.investment_purpose || '',
            politically_exposed:
              typeof data.politically_exposed === 'boolean'
                ? data.politically_exposed
                : false,
            country_of_residence: data.country_of_residence || '',
          });

          await preloadFilesFromKYC(data, setFiles);
          updateProgress(data, {});
        }
      });
      await getUserAML(userToUpdate.id).then(async ({ data }) => {
        setAML(data);
        if (data.error) {
          if (data.error === 'AML introuvable') {
          }
        } else {
          setAML(data);
        }
      });
    }

    setIsLoading(false);
  };

  const preloadFilesFromKYC = async (kycData, setFiles) => {
    const fileKeys = [
      'id_document_front',
      'id_document_back',
      'selfie',
      'proof_of_residency',
    ];

    for (const key of fileKeys) {
      const fileUrl = kycData[key];
      if (fileUrl) {
        try {
          const response = await fetch(BASE_MEDIA + fileUrl);
          const blob = await response.blob();

          const fileExtension = fileUrl.split('.').pop();
          const filename = `${key}.${fileExtension}`;

          const file = new File([blob], filename, { type: blob.type });

          setFiles((prev) => ({
            ...prev,
            [key]: file,
          }));
        } catch (error) {
          console.error(`Erreur lors du chargement du fichier ${key}`, error);
        }
      }
    }
  };

  const showModal = (val) => {
    setIsModalVisible(true);
    setpreviewImage(val);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const updateProgress = (data, fileData) => {
    const totalFields = 14;
    let filled = 0;
    Object.values(data).forEach((val) => {
      if (val && val !== '') filled++;
    });
    Object.values(fileData).forEach((val) => {
      if (val) filled++;
    });
    const percent = Math.min(Math.round((filled / totalFields) * 100), 100);
    setCompletion(percent);
  };

  return (
    <div>
      <Container>
        <div className='top' style={{ padding: 10, marginBottom: 5 }}>
          <Space>
            <div style={{ color: 'orange' }}>KYC de {userToUpdate?.nom}</div>
            <div>
              <strong>Statut KYC :</strong>
              {kyc.status ? (
                <Tag
                  color={
                    kyc.status === 'verified'
                      ? 'green'
                      : kyc.status === 'submitted'
                      ? 'yellow'
                      : kyc.status === 'pending'
                      ? 'orange'
                      : kyc.status === 'rejected'
                      ? 'red'
                      : 'default'
                  }
                >
                  {kyc.status.toUpperCase()}
                </Tag>
              ) : (
                <Tag color='default'>Non soumis</Tag>
              )}
            </div>
          </Space>
          <Space style={{ marginTop: 20 }}>
            <div style={{ color: 'black' }}>
              {' '}
              <b>Score AML:</b> {aml.aml_risk_score ? aml.aml_risk_score : '-'}
            </div>
            <div>
              <strong>Niveau AML :</strong>
              {aml.aml_risk_level ? (
                <Tag
                  color={
                    aml.aml_risk_level === 'Faible'
                      ? 'green'
                      : kyc.status === 'Moyen'
                      ? 'orange'
                      : kyc.status === 'Eleve'
                      ? 'red'
                      : 'default'
                  }
                >
                  {aml.aml_risk_level.toUpperCase()}
                </Tag>
              ) : (
                <Tag color='default'>Non calcule</Tag>
              )}
            </div>
          </Space>
        </div>
        <div className='content'>
          <div style={{ margin: 5 }}>
            <div className='flex items-center justify-between'>
              <div className='flex items-center gap-4'>
                <Progress
                  percent={completion}
                  size='small'
                  status={completion === 100 ? 'success' : 'active'}
                />
              </div>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <Input
                type='date'
                name='birth_date'
                placeholder='Date de naissance'
                value={formData.birth_date}
                onChange={handleInput}
              />
              <Input
                name='nationality'
                placeholder='Nationalité'
                value={formData.nationality}
                onChange={handleInput}
              />
              <Input
                name='country_of_residence'
                placeholder='Pays de résidence'
                value={formData.country_of_residence}
                onChange={handleInput}
              />
              <Input
                name='id_type'
                placeholder='Type de pièce (ex: CNI, Passeport)'
                value={formData.id_type}
                onChange={handleInput}
              />
              <Input
                name='id_number'
                placeholder='Numéro de pièce'
                value={formData.id_number}
                onChange={handleInput}
              />
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <Upload
                accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith('image/');
                  if (!isImage) {
                    message.error('Seules les images sont autorisées');
                    return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                  }

                  handleFile('id_document_front', file);
                  return false; // empêche l'upload automatique
                }}
                showUploadList={false}
              >
                <Button>Document - Recto</Button>
              </Upload>

              {kyc.id_document_front && (
                <div>
                  <img
                    src={BASE_MEDIA + kyc.id_document_front}
                    className='photo'
                    alt='Document Recto'
                    onClick={() =>
                      showModal(BASE_MEDIA + kyc.id_document_front)
                    }
                    style={{ maxWidth: '300px', marginTop: '10px' }}
                  />
                </div>
              )}

              <Upload
                accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith('image/');
                  if (!isImage) {
                    message.error('Seules les images sont autorisées');
                    return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                  }

                  handleFile('id_document_back', file);
                  return false; // empêche l'upload automatique
                }}
                showUploadList={false}
              >
                <Button>Document - Verso</Button>
              </Upload>

              {kyc.id_document_back && (
                <div>
                  <img
                    src={BASE_MEDIA + kyc.id_document_back}
                    alt='Document Recto'
                    className='photo'
                    onClick={() => showModal(BASE_MEDIA + kyc.id_document_back)}
                    style={{ maxWidth: '300px', marginTop: '10px' }}
                  />
                </div>
              )}

              <Upload
                accept='image/*' // 🔒 accepte uniquement les images côté navigateur
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith('image/');
                  if (!isImage) {
                    message.error('Seules les images sont autorisées');
                    return Upload.LIST_IGNORE; // 🚫 ignore le fichier
                  }

                  handleFile('selfie', file);
                  return false; // empêche l'upload automatique
                }}
                showUploadList={false}
              >
                <Button>Selfie</Button>
              </Upload>
              {kyc.selfie && (
                <div>
                  <img
                    src={BASE_MEDIA + kyc.selfie}
                    alt='Document Verso'
                    className='photo'
                    onClick={() => showModal(BASE_MEDIA + kyc.selfie)}
                    style={{ maxWidth: '300px', marginTop: '10px' }}
                  />
                </div>
              )}
              <Upload
                beforeUpload={(file) => (
                  handleFile('proof_of_residency', file), false
                )}
              >
                <Button>Justificatif de domicile</Button>
              </Upload>
              {kyc.proof_of_residency && (
                <a
                  href={BASE_MEDIA + kyc.proof_of_residency}
                  target='_blank'
                  className='button'
                  rel='noopener noreferrer'
                >
                  Voir
                </a>
              )}
              <br />
              <Upload
                beforeUpload={(file) => (
                  handleFile('proof_of_revenue', file), false
                )}
              >
                <Button>Justificatif de revenue</Button>
              </Upload>
              {kyc.proof_of_revenue && (
                <a
                  href={BASE_MEDIA + kyc.proof_of_revenue}
                  target='_blank'
                  className='button'
                  rel='noopener noreferrer'
                >
                  Voir
                </a>
              )}
              <br />
            </div>

            <Input.TextArea
              name='address'
              placeholder='Adresse complète'
              value={formData.address}
              onChange={handleInput}
              rows={2}
            />

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <Input
                name='employment_status'
                placeholder='Profession'
                value={formData.employment_status}
                onChange={handleInput}
              />
              <Input
                name='investment_purpose'
                placeholder="Objectif d'investissement"
                value={formData.investment_purpose}
                onChange={handleInput}
              />
              <br />
              <label>Personne Politiquement Expose?: </label>
              <Select
                value={formData.politically_exposed}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    politically_exposed: value,
                  }))
                }
                options={[
                  { label: 'Oui', value: true },
                  { label: 'Non', value: false },
                ]}
              />
              <br />
              <label>Revenue: </label>
              <Select
                value={formData.income_level}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    income_level: value,
                  }))
                }
                options={[
                  { value: 'Non déclaré', label: 'Non déclaré' },
                  {
                    value: 'Faible',
                    label: 'Faible (< 100 000 XAF/mois)',
                  },
                  {
                    value: 'Moyen',
                    label: 'Moyen (100 000 à 500 000 XAF/mois)',
                  },
                  {
                    value: 'Élevé',
                    label: 'Élevé (> 500 000 XAF/mois)',
                  },
                  {
                    value: 'Très élevé',
                    label: 'Très élevé (> 1 000 000 XAF/mois)',
                  },
                ]}
              />
            </div>

            <div className='pt-6'>
              <Button
                onClick={handleSubmit}
                loading={isLoading}
                className='w-full md:w-auto'
              >
                {kyc && kyc.id ? 'Mettre à jour' : 'Soumettre'}
              </Button>
            </div>
          </div>
        </div>
        <Modal
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          centered
        >
          <img
            src={previewImage}
            alt='Aperçu agrandi'
            style={{ width: '100%' }}
          />
        </Modal>
      </Container>
    </div>
  );
};
